import React, { useState } from "react";
import { CalendarCheck, CalendarX, Clock, Coffee, Hourglass, Plane } from "lucide-react";
import * as api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useData } from "@/hooks/useData";
import { Field, Input, Loader, PageHeader, StatCard, TableCard } from "@/components/ui";
import { AttendanceTable } from "@/components/hrms";
import { currentMonth, monthLabel } from "@/lib/format";

export default function AttendanceHistory() {
  const { user } = useAuth();
  const [month, setMonth] = useState(currentMonth());
  const { data: s } = useData(() => api.attendance.monthly(user.employee_id, month), [user.employee_id, month]);

  return (
    <>
      {s && (
        <div className="grid gap-3 grid-cols-2 md:grid-cols-3 xl:grid-cols-6">
          <StatCard label="Present" value={s.present} icon={CalendarCheck} color="green" />
          <StatCard label="Absent" value={s.absent} icon={CalendarX} color="red" />
          <StatCard label="Half Day" value={s.half_day} icon={Coffee} color="orange" />
          <StatCard label="On Leave" value={s.on_leave} icon={Plane} />
          <StatCard label="Late Arrivals" value={s.late} icon={Clock} color="orange" />
          <StatCard label="Total Hours" value={s.total_hours.toFixed(1)} icon={Hourglass} />
        </div>
      )}

      <PageHeader
        description="Your daily punch records for the selected month."
        actions={<Field label="Month"><Input type="month" value={month} max={currentMonth()} onChange={(e) => e.target.value && setMonth(e.target.value)} className="w-44" /></Field>}
      />

      {!s ? <Loader /> : (
        <TableCard heading={`${s.records.length} records`} aside={monthLabel(month)}>
          <AttendanceTable records={s.records} empty={{ title: "No records", message: "There's no attendance for this month." }} />
        </TableCard>
      )}
    </>
  );
}
